export const increment_question_counter = "increment_question_counter";
export const increment_score = "increment_score";
